import { Action, IOWidget, mk_widget } from 'widgets-for-react'
import React from 'react'
import { CMSState, Url } from '../../../../cms/blocks/types.gen'
import { getClassName, link, isLinkExternal, possiblyStripUrlToPath } from '../../../../cms/blocks/utils.gen'
import { CustomBlockData } from '../types.mod'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { PublicSiteState } from '../../../../public_site.main.mod'
import { decodeHTMLEntities } from '../../../../../helpers'

export type LinkBlockProps = {
  title: string
  intro?: string
  items: LinkProps[]

  show_in_page_navigation: boolean
  navigation_title: string
}

export type LinkProps = { key?: string; title: string; url: Url; target?: '_blank' | '_self' }

export type LinkBlockStyle = Partial<{
  block_classname: string
  inner_classname: string
  header_classname: string
  title_classname: string
  intro_classname: string
  content_classname: string
  list_classname: string
  item_classname: string
  item_label_classname: string
  item_icon_classname: string
  link_classname: string
}>

export function LinkBlock<customBlockData, extra_images>(
  props: LinkBlockProps,
  options?: {
    style?: LinkBlockStyle
    key?: string
  }
): (s: CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (_: CMSState<CustomBlockData, extra_images, PublicSite_CustomPageData>) => (public_state: PublicSiteState) =>
    mk_widget({
      run: _ => (
        <section
          id={props.navigation_title}
          className={getClassName(options, 'block_classname', 'container')}
          key={options && options.key ? options.key : 'link-block'}
        >
          <div className={getClassName(options, 'inner_classname', 'py-5')}>
            <header className={getClassName(options, 'header_classname', '')}>
              {props.title && <h2 className={getClassName(options, 'title_classname', 'mb-3')}>{decodeHTMLEntities(props.title)}</h2>}
              {props.intro && <div className={getClassName(options, 'intro_classname', '')} dangerouslySetInnerHTML={{ __html: props.intro }} />}
            </header>

            <div className={getClassName(options, 'content_classname', '')}>
              <ul className={getClassName(options, 'list_classname', 'list-unstyled mb-0 row')}>
                {props.items.map((l, _) => (
                  <li className={getClassName(options, 'item_classname', 'col-md-6')} key={l.key}>
                    {l.title && l.url
                      ? link(
                        {
                          kind: 'link',
                          title: l.title,
                          url: possiblyStripUrlToPath(l.url),
                          is_link_external: isLinkExternal(l.url),
                          target: l.target == undefined ? '_self' : isLinkExternal(l.url) ? '_blank' : '_self'
                        },
                        {
                          classname: getClassName(
                            options,
                            'link_classname',
                            'btn btn-link w-100 text-left border-bottom rounded-0 pl-0'
                          )
                        },
                        <>
                          <span className={getClassName(options, 'item_label_classname', 'col-md-6')}>{l.title}</span>
                          <svg className={getClassName(options, 'item_icon_classname', 'col-md-6')} width="24px" height="24px" aria-hidden="true">
                            <use xlinkHref='#icon--arrow' />
                          </svg>
                        </>
                      )
                      : null}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </section>
      )
    })
}



// WEBPACK FOOTER //
// ./Client/components/public_site/blocks/custom_blocks/widgets/linkBlock.mod.tsx